<ion-header class=ion-no-border>
    <ion-toolbar mode="ios">
        <ion-title>{{'Documents' | translation}}</ion-title>
        <ion-buttons slot="end">
            <ion-button fill="clear" (click)="dismiss()">
                <ion-icon name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list class="list-wrap">
        <ion-list-header class="list-wrap-header">
            <ion-grid>
                <ion-row>
                    <ion-col>
                        <label class="btn btn-default">
                            <ion-label position="floating">{{'DocumentTitle' | translation}}</ion-label>
                            <ion-input [(ngModel)]="document_title" style="border-radius: 8px;margin-top: 8px;border: 1px solid #eee3e3;"></ion-input>
                        </label>
        
                        <label class="btn btn-default">
                            <ion-input id="uploadCaptureInputFile" type="file" (change)="selectFile($event)" accept=".jpeg,.jpg,.png,.gif,.mp4,.avi,.mov,.webm,.wmv,.txt,.pdf"></ion-input>
                        </label>
            
                        <ion-button expand="block" [disabled]="!selectedFiles && !document_title" (click)="upload()">{{'Upload' | translation}}</ion-button>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-list-header>

        <!-- Admin Documents -->
        <ion-item-divider>
            <ion-label>{{'AdminDocuments' | translation}}</ion-label>
        </ion-item-divider>

        <ion-item button *ngFor="let item of adminData; let i=index" (click)="selectedMessage(item)">
            <div class="previewWrap">
                <div *ngIf="item.file_type === 'image'" class="gallery-img">
                    <img class="img" src="{{item.url}}"/>
                </div>

                <div *ngIf="item.file_type === 'video'" class="gallery-video">
                    <video class="video" poster="../../../assets/images/player-btn-overlay.png">
                        <source src="{{item.url}}">
                    </video>
                </div>

                <div *ngIf="item.file_type === 'file'" class="doc-file">
                    <ion-icon name="document" class="document" size="large" color="primary"></ion-icon>
                    <span style="visibility: hidden">{{item.url}}</span>
                </div>
            </div>

            <p class="ion-padding-start"><span style="font-weight: bold; font-size: small;">{{item.title ? item.title : 'NoTitle' | translation }}</span></p>

            <div slot="end">
                <ion-button *ngIf="item.uploaded_by === 'O'" class="small-round-btn" (click)="deleteDocument(item)" color="danger" shape="round" size="small">
                    <ion-icon name="trash" slot="icon-only"></ion-icon>
                </ion-button>
            </div>
        </ion-item>

        <!-- My Documents -->
        <ion-item-divider>
            <ion-label>{{'MyDocuments' | translation}}</ion-label>
        </ion-item-divider>

        <ion-item button *ngFor="let item of myData; let i=index" (click)="selectedMessage(item)">
            <div class="previewWrap">
                <div *ngIf="item.file_type === 'image'" class="gallery-img">
                    <img class="img" src="{{item.url}}"/>
                </div>

                <div *ngIf="item.file_type === 'video'" class="gallery-video">
                    <video class="video" poster="../../../assets/images/player-btn-overlay.png">
                        <source src="{{item.url}}">
                    </video>
                </div>

                <div *ngIf="item.file_type === 'file'" class="doc-file">
                    <ion-icon name="document" class="document" size="large" color="primary"></ion-icon>
                    <span style="visibility: hidden">{{item.url}}</span>
                </div>
            </div>

            <p class="ion-padding-start"><span style="font-weight: bold; font-size: small;">{{item.title ? item.title : 'NoTitle' | translation }}</span></p>

            <div slot="end">
                <ion-button *ngIf="item.uploaded_by === 'O'" class="small-round-btn" (click)="deleteDocument(item)" color="danger" shape="round" size="small">
                    <ion-icon name="trash" slot="icon-only"></ion-icon>
                </ion-button>
            </div>
        </ion-item>
    </ion-list>
</ion-content>



